import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import Hero from "@/components/sections/Hero";
import BrandMarquee from "@/components/sections/BrandMarquee";
import About from "@/components/sections/About";
import Packages from "@/components/sections/Packages";
import Faq from "@/components/sections/Faq";
import Contact from "@/components/sections/Contact";

export default function Home() {
  const location = useLocation();
  const packagesRef = useRef(null);

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace("#", "");
      setTimeout(() => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth" });
      }, 300);
    } else {
      window.scrollTo(0, 0);
    }
  }, [location]);

  const scrollToPackages = () => {
    document.getElementById("packages")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="bg-cream" ref={packagesRef}>
      <Nav />
      <Hero onViewPackages={scrollToPackages} />
      <BrandMarquee />
      <About />
      <Packages />
      <Faq />
      <Contact />
      <Footer />
    </div>
  );
}
